import { render, staticRenderFns } from "./GreenBeanLot.vue?vue&type=template&id=6f50bfe9&scoped=true"
import script from "./GreenBeanLot.vue?vue&type=script&lang=js"
export * from "./GreenBeanLot.vue?vue&type=script&lang=js"
import style0 from "./GreenBeanLot.vue?vue&type=style&index=0&id=6f50bfe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f50bfe9",
  null
  
)

export default component.exports